module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample197x166-f3a3881f3a99e8d3df547c2d50e4a135.jpeg";